<template>
  <div
    class="link-box"
    style="width: 100%; height: 100%"
  >
    <!-- eod提示 -->
    <div
      v-show="isSecurity && eodTipH"
      class="link-header-tip"
      :style="{height: `${eodTipH}px`, 'line-height': `${eodTipH}px`}"
    >
      {{ $t('该文件的安全级别较高，您需要下载专用软件才可以使用（仅支持windows用户）') }}<!--
            --><a
      href="/client/eod-Sandbox-plug-in/zBox_eod.rar"
      class="download-area"
>{{ $t('点击下载') }}</a>{{ $t('软件') }}
      <svg
        class="close-icon"
        @click="closeHeaderTip"
      >
        <use xlink:href="#close" />
      </svg>
    </div>
    <!-- 容器整体的部局 bs-structure组件的prop请仔细哦-->
    <bs-structure
      :display-right="false"
      :box-tip-h="0"
      :s-full-screen="false"
      :box-margin-r="60"
      :box-margin-l="60"
    >
      <!-- header -->
      <template slot="boxHeader">
        <bs-header
          :data="data"
          :is-show-login="false"
        />
      </template>
      <!-- body -->
      <template slot="boxBody">
        <div class="link-box-body">
          <!-- P.S. 这里放预览组件/文件列表组件/异常组件/验证码组件 -->
          <bs-password
            v-if="showAuth === 'pwdAuth'"
            :share-info="shareInfo"
            @changeToSmAuth="switchToSmAuth"
            @getPasswordToken="authToken"
          />
          <bs-smartAuth
            v-if="showAuth === 'smartAuth'"
            :share-info="shareInfo"
            @getSmToken="authToken"
          />
          <div class="lenovo-right">
            ©Filez
          </div>
        </div>
      </template>
    </bs-structure>
  </div>
</template>
<script>
import bsStructure from 'components/business/structure/index.vue'
import bsSmartAuth from 'components/business/link/auth/smartAuth.vue'
import bsPassword from 'components/business/link/auth/password.vue'
import bsHeader from 'components/business/link/header/index.vue'
import { resolveMultiDomain } from 'util/util.js'

export default {
  components: {
    bsStructure,
    bsSmartAuth,
    bsPassword,
    bsHeader,
  },
  props: {
    /**
         * 链接的相关信息，也包含sm相关的
         */
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      eodTipH: 0, // 安全外链的eod下载提示的高度，如果是0则没有
      showSmAuth: false, // 是否显示sm验证
      authData: { // 验证最终生成预览需要的参数
        token: '',
        password: '',
      },
    }
  },
  computed: {
    /**
         * 处理传进来的data，包含外链信息和smartshare相关信息
         */
    shareInfo() {
      const shareInfo = { ...this.data.ext }
      shareInfo._id = this.data.deliverycode // _id为外链的delivery_code
      return shareInfo
    },
    /**
         * 是否是安全外链
         */
    isSecurity() {
      if (this.shareInfo.security !== 0) this.eodTipH = 44
      return this.shareInfo.security !== 0
    },
    /**
         * 判断哪种验证类型
         */
    showAuth() {
      if (this.showSmAuth) return 'smartAuth'
      if (this.shareInfo.protected) {
        return 'pwdAuth'
      } if (this.shareInfo.is_smartshare && this.shareInfo.receiver_setting != 0) {
        return 'smartAuth'
      }
    },
  },
  methods: {
    /**
         * 从password切换到sm验证
         */
    switchToSmAuth(data) {
      this.authData = { ...data }
      this.showSmAuth = true
    },
    /**
         * 返回验证成功后的token
         */
    authToken(data) {
      Object.assign(this.authData, data)
      // 记localstorage
      const option = {
        token: this.authData.token,
        password: this.authData.password,
        folder_id: this.shareInfo._id,
        emobile: this.authData.emobileNum || '',
        startTime: new Date().getTime(),
      }
      localStorage.setItem(`linkToken${this.shareInfo._id}`, JSON.stringify(option))
      if (this.shareInfo.is_smartshare === 1) {
        Object.assign(option, { emobileNum: this.authData.emobileNum })
        localStorage.setItem(`smartshareLinkToken${this.shareInfo._id}`, JSON.stringify(option))
      }
      this.$emit('authToken', this.authData)
    },
    /*
        * 关闭eod header tip
        */
    closeHeaderTip() {
      this.eodTipH = 0
    },
    /**
         * 回去eod下载地址
         */
    eodUrl() {
      // if (document.domain.indexOf('.cn') > -1) return "https://res.box.lenovo.com.cn/download/eod.rar";
      // return "https://res.box.lenovo.com/download/eod.rar";
      return resolveMultiDomain('https://res.box.lenovo.com/download/eod.rar')
    },
  },
}
</script>
<style lang="less" scoped>
@import '~less/link.less';
.link-box{
  // 头部button区
  .link-button-group{
    float: right;
    height: 50px;
    line-height: 50px;
  }
  // 中间区域
  .link-box-body{
    background:#FFFFFF;
    overflow-y: auto;
  }
  // 头部tip
  .link-header-tip{
    font-size: 14px;
    line-height: 20px;
    position: relative;
    .download-area{
      color: #005EFE;
    }
    .close-icon{
      width: 14px;
      height: 14px;
      vertical-align: middle;
      position: absolute;
      top: 50%;
      right: 0px;
      margin-top: -7px;
      margin-right: 24.6px;
      cursor: pointer;
    }
  }
}
// 版权信息
.lenovo-right{
  font-size: 12px;
  color: #93a0b3;
  text-align: center;
  margin: auto;
  position: absolute;
  bottom: 49px;
  width: 100%;
}
</style>
